import { format, unformat } from '@react-input/mask';
import { masks } from '@/constants/validation';

class MaskService {
  public static mask(field: keyof typeof masks, value: string) {
    return format(value, masks[field]);
  }

  public static unmask(field: keyof typeof masks, value: string) {
    return unformat(value, masks[field]);
  }

  public static formatPhoneForDisplay(value: string | null | undefined): string {
    if (!value) return '';

    const stringValue = String(value);
    const digits = stringValue.replace(/\D/g, '');

    if (digits.length === 10) {
      return format(digits, masks.mobilePhone);
    }

    if (digits.length === 11 && digits.startsWith('1')) {
      return `1 ${format(digits.slice(1), masks.mobilePhone)}`;
    }

    return stringValue;
  }

  public static maskInputValueToHide(input: string, digitsToMask = 5): string {
    let count = 0;

    return input
      .split('')
      .map((char) => {
        if (/[a-zA-Z0-9]/.test(char)) {
          count++;
          return count <= digitsToMask ? '*' : char;
        }
        return char;
      })
      .join('');
  }
}

export default MaskService;
